var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications",on:{"click":_vm.openNotificationPanel}},[_c('a',{staticClass:"nav-link",attrs:{"role":"button"}},[_c('i',{staticClass:"fi fi-rr-bell"}),_vm._v(" "),_c('span',{staticClass:"badge bg-danger rounded-pill badge-counter"},[_vm._v(_vm._s(_vm.unread > 0 ? (_vm.unread > 9 ? '9+' : _vm.unread) : ''))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }